import React, { createContext, useState } from "react";

export const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const [getError, setGetError] = useState("");

  const login = (token) => {
    setGetError("");
    localStorage.setItem("token", token);
    setIsLoggedIn(true);
  };

  const logout = () => {
    localStorage.removeItem("token");
    setGetError(`You've been logged out. Please log back in.`);
    setIsLoggedIn(false);
  };

  return (
    <LoginContext.Provider
      value={{ isLoggedIn, login, logout, getError, setGetError }}
    >
      {children}
    </LoginContext.Provider>
  );
};
